export default __webpack_public_path__ + "static/media/24.08b7a7d3.jpg";